/**
 * Related Products Slider
 * Initializes Flickity only when 6+ products exist
 * - No looping (wrapAround: false)
 * - Current product always first (initialIndex: 0, cellAlign: 'left')
 */
document.addEventListener('DOMContentLoaded', function() {
  const sliderWrapper = document.querySelector('.related-products-slider-wrapper');

  if (!sliderWrapper) return;

  const slider = sliderWrapper.querySelector('.related-products-slider');
  const enableSlider = sliderWrapper.dataset.enableSlider === 'true';
  const productsCount = parseInt(sliderWrapper.dataset.productsCount, 10);

  // Only initialize Flickity if 6+ products and Flickity is available
  if (enableSlider && productsCount >= 6 && typeof Flickity !== 'undefined') {
    const flkty = new Flickity(slider, {
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      freeScroll: false,
      wrapAround: false,
      contain: true,
      cellAlign: 'left',
      initialIndex: 0,
      groupCells: false,
      arrowShape: 'M45.107632 5.82952 L53.53207 14.795201 L24.285714 46.292352 L97.808833 46.292352 L97.808833 59.383744 L24.285714 59.383744 L53.53207 90.877568 L45.107615 99.952178 L1.377755 53.778731 L45.107632 5.82952 Z'
    });

    // Update arrow visibility based on scroll position
    function updateArrows() {
      const prevBtn = slider.querySelector('.flickity-prev-next-button.previous');
      const nextBtn = slider.querySelector('.flickity-prev-next-button.next');

      // Hide prev button at start
      if (prevBtn) {
        const isAtStart = flkty.x >= 0;
        prevBtn.style.display = isAtStart ? 'none' : '';
      }

      // Hide next button at end
      if (nextBtn) {
        const lastCell = flkty.cells[flkty.cells.length - 1];
        if (lastCell) {
          const sliderWidth = flkty.size.innerWidth;
          const lastCellEnd = lastCell.x + lastCell.size.width;
          const scrollEnd = lastCellEnd - sliderWidth;
          // 5px tolerance for rounding errors
          const isAtEnd = Math.abs(flkty.x) >= scrollEnd - 5;
          nextBtn.style.display = isAtEnd ? 'none' : '';
        }
      }
    }

    // Attach to Flickity events
    flkty.on('change', updateArrows);
    flkty.on('settle', updateArrows);
    flkty.on('scroll', updateArrows);

    // Force layout recalculation after initialization
    flkty.resize();

    // Set initial arrow state
    updateArrows();

    // Handle window resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        flkty.resize();
        updateArrows();
      }, 250);
    });
  }
});
